import styled from "@emotion/styled";
import { Layout } from "antd";
import { genericStyles } from "../../../constant";

const { Content } = Layout;

export const StyledLayout = styled(Layout)`
  height: 100dvh;
  overflow: hidden;

  .side-bar {
    overflow: auto;
    height: 100dvh;
    position: sticky;
    inset-inline-start: 0;
    top: 0;
    scrollbar-width: thin;
    scrollbar-gutter: stable;
    background: white;
    border-right: 1px solid #e5e7eb;
    flex: 0 0 70px !important;
    max-width: 70px !important;
    min-width: 70px !important;
    width: 70px !important;
    background: var(--primary);
    ul {
      background: var(--primary);
    }
    .header {
      padding: 10px 0px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
      cursor: pointer;
      .logo-image {
        height: 35px;
        width: 35px;
      }
    }
    .ant-menu-item-icon {
      font-size: 24px;
      margin-left: -6px;
      margin-top: 10px;
      color: white !important;
    }

    .ant-menu-item-selected {
      background: var(--linear-bg);
      border: 1px solid white !important;
      color: white;
    }
    .logout-div {
      position: absolute;
      bottom: 40px;
      display: flex;
      width: 100%;
      justify-content: center;
      padding: 0px 10px;
    }
  }

  @media (max-width: 767px) {
    .main-content-div {
      height: calc(100% - 64px);
    }
  }
`;

export const StyledContent = styled(Content)`
  margin-left: ${(props) =>
    // @ts-ignore
    props.sidebarCollapsed ? "70px" : "260px"};
  margin-top: 64px;
  padding: 24px;
  background: ${genericStyles.outsideBgColor};
  min-height: calc(100dvh - 64px);
  overflow-y: auto;
  transition: margin-left 0.3s ease;
`;
